export default "__VITE_ASSET__hGgxZfBP__"